import { render, staticRenderFns } from "./UpdateCustomer.vue?vue&type=template&id=43d573c4"
import script from "./UpdateCustomer.vue?vue&type=script&lang=js"
export * from "./UpdateCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports